import { BaseService } from "src/services/baseService";
import { ReceivingDiscrepancyAPIService } from "./receivingDiscrepancyAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { ReceivingDiscrepancy, IssueStatus } from "src/types";

class ReceivingDiscrepancyService extends BaseService<ReceivingDiscrepancyAPIService> {
  @sanitiseParams()
  async getPurchaseOrderReceivingDiscrepancy(
    purchaseOrderId: string,
    receivingDiscrepancyStatus?: IssueStatus
  ): Promise<ReceivingDiscrepancy | undefined> {
    const receivingDiscrepancy = await this.apiService.getPurchaseOrderReceivingDiscrepancyById(purchaseOrderId, {
      receivingDiscrepancyStatus
    });

    return receivingDiscrepancy;
  }

  @sanitiseParams()
  async resolvePurchaseOrderReceivingDiscrepancy(
    purchaseOrderId: string,
    resolutionDetails: string
  ): Promise<ReceivingDiscrepancy | undefined> {
    const updatedReceivingDiscrepancy = await this.apiService.patchPurchaseOrderReceivingDiscrepancyResolution(
      purchaseOrderId,
      { resolutionDetails }
    );

    return updatedReceivingDiscrepancy;
  }
}

export { ReceivingDiscrepancyService };
